module.exports = __webpack_public_path__ + "0d870da0b93f7dcfab85d2765bf89d2c.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/feet/shoes-high-heels-pink-s.png
// module id = 1927
// module chunks = 0